<script setup>
import {defineProps, reactive} from "vue";
import EmailFormStep from "./components/steps/EmailFormStep.vue";
import PersonalDataFormStep from "./components/steps/PersonalDataFormStep.vue";
import CodeVerificationFormStep from "./components/steps/CodeVerificationFormStep.vue";
import RequestSubmittedStep from "./components/steps/RequestSubmittedStep.vue";
import ExistDataFormStep from "./components/steps/ExistDataFormStep.vue";
import {createFlowState} from "./flow-state";

require('./style.scss');

const {
  flowId,
  franchiseId,
  franchiseName,
  pageName
} = defineProps(['flowId', 'franchiseId', 'franchiseName', 'pageName']);

const flowState = createFlowState(
    reactive({
      form: {
        flowId,
        franchiseId,
        franchiseName,
        pageName,
        email: null,
        signUp: true,
        firstName: null,
        lastName: null,
        phoneNumber: null,
        fullPhoneNumber: null,
        franchise: null,
        liquidCapital: null,
	      country: 'United States',
        location: null,
	      timeframe: null,
	      consultWithSpecialist: 'Yes',
	      source: 'Franchise Specialist consult'
      },
      currentStep: 0,
      validation: null,
      prevPhoneNumber: 0,
      timeRemaining: 59, // time in seconds for countdown
      countDown: false, // flag for countdown
      verifyAttempts: 4, // user attempts after phone validation
      phoneChanged: false, // phone changed after prev validation (step 3 to 2)
      backToStep2: false, // flag to check if user back from 3 to 2
      submitHubspot: false, // send data to hubspot
    })
);

// if CFF registration cookie is set and page not requested
if (flowState.getCookie('cffRegistration') && flowState.getCookie('cffPageRequested').indexOf(flowState.franchiseId()) === -1) {
    // Go to last step
    flowState.existDataStep()
}
else if (flowState.getCookie('cffRegistration') && flowState.getCookie('cffPageRequested').indexOf(flowState.franchiseId()) >= 0) {
    // Go to last step
    flowState.lastStep()
}

</script>

<template>
  <div class="vf-ccf-embed mx-5" :id="flowId" tabindex="-1" aria-labelledby="Contact Form"
       aria-hidden="true">
    <div class="modal-dialog DO_NOT_APPLY_OLD_STYLES modal-dialog-centered">
      <div class="modal-content form-flow">
        <div class="modal-body">
          <EmailFormStep :visible="flowState.currentStepIs(0)" :flowState="flowState"/>
          <PersonalDataFormStep :visible="flowState.currentStepIs(1)" :flowState="flowState"/>
          <CodeVerificationFormStep :visible="flowState.currentStepIs(2)" :flowState="flowState"/>
          <RequestSubmittedStep :visible="flowState.currentStepIs(3)" :flowState="flowState"/>
          <ExistDataFormStep :visible="flowState.currentStepIs(4)" :flowState="flowState"/>
        </div>
      </div>
    </div>
  </div>
</template>


